import classNames from 'classnames'
import { MouseEvent, useMemo } from 'react'
import { Link } from 'react-router-dom'
import sanitizeHTML from 'sanitize-html'

import { ILinkButtonProps } from 'core-components/library/button/models/ILinkButtonProps'
import { ProcessingText } from 'core-components/library/loader'

import styles from './LinkButton.module.scss'

export const LinkButton = ({
  target,
  to,
  text,
  loading,
  icon,
  iconPosition,
  onClick,
  disabled,
  className,
  color,
}: ILinkButtonProps) => {
  const commonProps = useMemo(() => {
    return {
      onClick: (e: MouseEvent) => {
        if (disabled || loading) {
          e.stopPropagation()
          e.preventDefault()
        } else if (onClick) {
          onClick(e)
        }
      },
      className: classNames(disabled || loading ? styles.disabled : '', className || ''),
    }
  }, [disabled, loading, onClick])

  const content = (
    <span className={styles.inner}>
      {icon && <i className={classNames(styles[`icon-${iconPosition}`], icon)} />}
      {loading ? <ProcessingText text={text} /> : <span className={styles.caption}>{text}</span>}
    </span>
  )

  if (target === '_blank') {
    return (
      <a {...commonProps} href={sanitizeHTML(to)} target={target} rel={'noreferrer'}>
        {content}
      </a>
    )
  }

  return (
    <Link {...commonProps} to={to} target={target} rel={'noreferrer'}>
      {content}
    </Link>
  )
}
